import { render } from "./HockeyHolidays.vue?vue&type=template&id=4c3aae22"
import script from "./HockeyHolidays.vue?vue&type=script&lang=js"
export * from "./HockeyHolidays.vue?vue&type=script&lang=js"

import "./HockeyHolidays.vue?vue&type=style&index=0&id=4c3aae22&lang=scss"

import exportComponent from "/Users/jburnett/Documents/TBA/hockey-scheduler/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__